import { render, staticRenderFns } from "./StatsBarChart.vue?vue&type=template&id=5588e37a&"
import script from "./StatsBarChart.vue?vue&type=script&lang=js&"
export * from "./StatsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports